import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8f617ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "club-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Athlete In Focus")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  id: "Male",
  class: "tabcontent"
}
const _hoisted_9 = {
  id: "Female",
  class: "tabcontent"
}
const _hoisted_10 = {
  id: "Relay",
  class: "tabcontent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_athletes_table = _resolveComponent("athletes-table")!
  const _component_relay_table = _resolveComponent("relay-table")!
  const _component_pull_refresh = _resolveComponent("pull-refresh")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.club)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.club.name) + " – " + _toDisplayString(_ctx.club.code), 1),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              id: "male-button",
              class: "tablinks",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTab($event, 'Male')))
            }, " Male "),
            _createElementVNode("button", {
              id: "female-button",
              class: "tablinks",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTab($event, 'Female')))
            }, " Female "),
            _createElementVNode("button", {
              id: "relay-button",
              class: "tablinks",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openTab($event, 'Relay')))
            }, " Relay ")
          ]),
          _createVNode(_component_pull_refresh, {
            modelValue: _ctx.isLoading,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isLoading) = $event)),
            onRefresh: _ctx.onRefresh,
            "pulling-text": "",
            "loosing-text": "update...",
            "loading-text": "fetch...",
            "success-text": "fetching.."
          }, {
            default: _withCtx(() => [
              (_ctx.athletesFocus.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_2,
                    _createElementVNode("table", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createVNode(_component_athletes_table, {
                            athletess: _ctx.athletesFocus,
                            athleteid: _ctx.athleteid,
                            meetid: _ctx.meetid
                          }, null, 8, ["athletess", "athleteid", "meetid"])
                        ])
                      ])
                    ]),
                    _hoisted_5,
                    _hoisted_6
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_athletes_table, {
                  athletess: _ctx.athletesMale,
                  athleteid: _ctx.athleteid,
                  meetid: _ctx.meetid
                }, null, 8, ["athletess", "athleteid", "meetid"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_athletes_table, {
                  athletess: _ctx.athletesFemale,
                  athleteid: _ctx.athleteid,
                  meetid: _ctx.meetid
                }, null, 8, ["athletess", "athleteid", "meetid"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_relay_table, {
                  relayEvents: _ctx.relayEvents,
                  clubName: _ctx.club.name
                }, null, 8, ["relayEvents", "clubName"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}